<header>
  <div class="header-first-row columns desktop">
    <div class="social-media column">
      <a
        href="https://facebook.com/twogetherflowers"
        target="_blank"
        alt="D&D Twogether - Flowers and More facebook oldala"
      >
        <img
          src="assets/facebook-icon-black.svg"
          width="30px"
          height="30px"
          alt="Facebook"
        />
      </a>
      <a
        href="https://instagram.com/twogetherflowers"
        target="_blank"
        alt="D&D Twogether - Flowers and More Instagram oldala"
      >
        <img
          src="assets/instagram-black-icon.svg"
          width="30px"
          height="30px"
          alt="instagram logó"
        />
      </a>
      <a
        href="https://www.tiktok.com/@twogetherflower"
        target="_blank"
        alt="D&D Twogether - Flowers and More TikTok oldala"
      >
        <img
          src="assets/tiktok-icon-black.svg"
          width="30px"
          height="30px"
          alt="TikTok"
        />
      </a>
    </div>
    <div class="logo column">
      <!-- Menü Desktop nézethez -->
      <app-top-nav></app-top-nav>
    </div>
    <div class="phone column">
      <button (click)="logout()">Kijelentkezés</button>
    </div>
  </div>
  <!-- Felső sor (social media bal oldalt, telefon jobb oldalt) -->
  <div class="header-top mobile">
    <div class="social-media">
      <a href="https://facebook.com/twogetherflowers" target="_blank">
        <img src="assets/facebook-icon-black.svg" alt="Facebook" />
      </a>
      <a href="https://instagram.com/twogetherflowers" target="_blank">
        <img src="assets/instagram-black-icon.svg" alt="Instagram" />
      </a>
      <a href="https://www.tiktok.com/@twogetherflower" target="_blank">
        <img src="assets/tiktok-icon-black.svg" alt="TikTok" />
      </a>
    </div>
    <div class="phone">
      <button (click)="logout()">Kijelentkezés</button>
    </div>
  </div>

  <!-- Logó középen -->
  <div class="logo mobile">
    <a routerLink="/">
      <img
        src="assets/logo-black.svg"
        alt="D&D Twogether - Flowers and More logó"
      />
    </a>
  </div>
</header>
